export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmação necessária"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A autorização deve ser confirmada com uma chave única"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A autorização deve ser confirmada com uma palavra mágica"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O registro deve ser confirmado com um código de mensagem SMS"])}
}